import { actions } from './reducer'
import ssapi from 'lib/api/secondstepApi'
import { addNotification } from 'store/notifications'
import { getReadableErrorMessage } from 'utils/errorUtils'
import { AppDispatch } from 'store/types'

export const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  return async function (dispatch: AppDispatch) {
    const file = event.target.files?.[0] || null
    dispatch(actions.setSelectedFile(file))
  }
}

export const handleUpload = ({ file }: { file: File }) => {
  return async function (dispatch: AppDispatch) {
    dispatch(actions.setIsSubmitting())
    const bodyFormData = new FormData()
    bodyFormData.set('sitesPreferences', file)

    try {
      const response = await ssapi.bulkUpdateSitePreferences(bodyFormData)
      const responseWithFile = { ...response, file }
      dispatch(actions.setSubmittingSuccess(responseWithFile))
      dispatch(
        addNotification({
          color: 'success',
          text: `site Preferences were updated. Check the CSV file`,
        }),
      )
    } catch (error: unknown) {
      const errorMsg = getReadableErrorMessage(
        error,
        "Something's gone wrong while uploading file. Please try again or file a ticket for assistance.",
      )
      dispatch(actions.setSubmittingError({ error: errorMsg, file }))

      dispatch(
        addNotification({
          color: 'danger',
          text: errorMsg,
        }),
      )
    }
  }
}
